<div class="modal-header">
  <h5 class="modal-title">Projekt auswählen</h5>
  <button type="button" class="btn-close" aria-label="Schliessen" (click)="closeModal()"></button>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-12">
      <bpw-search-box
        #prSearchBox
        [databinding]="databindingPr"
        (rowClicked)="prSelectedInternal($event)"
      ></bpw-search-box>
    </div>
  </div>
</div>
